import React from 'react';
import { IconButton } from '@radix-ui/themes';
import { Cross2Icon } from '@radix-ui/react-icons';

/**
 * Consistent top-right close button for all dialogs/modals.
 * Usage: place it as the first child inside Dialog.Content.
 *
 * @param {function} onClose - Handler to call when the button is clicked.
 */
const DialogCloseButton = ({ onClose }) => (
  <IconButton
    type="button"
    size="1"
    variant="ghost"
    color="gray"
    aria-label="Close dialog"
    onClick={onClose}
    style={{ position: 'absolute', top: '16px', right: '16px', cursor: 'pointer' }}
  >
    <Cross2Icon width="18" height="18" />
  </IconButton>
);

export default DialogCloseButton;
